import { Route } from '@angular/router';
import { BUYER_ROUTES, COMMON_AUTHENTICATED_ROUTES } from './routes';

import { authGuard, noAuthGuard } from '@ps/auth-data-access';

export const routes: Route[] = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [noAuthGuard],
    loadComponent: () =>
      import('./layouts/basic-layout/basic-layout.component').then(
        (m) => m.BasicLayoutComponent,
      ),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.page').then((m) => m.LoginPage),
        title: 'Log In',
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.page').then(
            (m) => m.ForgotPasswordPage,
          ),
        title: 'Forgot Password?',
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/app-layout/app-layout.component').then(
        (m) => m.AppLayoutComponent,
      ),
    children: [...COMMON_AUTHENTICATED_ROUTES, ...BUYER_ROUTES],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/status-pages/not-found/not-found.page').then(
        (m) => m.NotFoundPage,
      ),
    title: 'Page Not Found',
  },
];
